/* eslint-disable jsx-a11y/no-onchange */
import { OnBoardingSelectProps } from '@/types/props/components/onboarding';
import clsx from 'clsx';
import SpiritoryLabel from './SpiritoryLabel';
import { MdClose } from 'react-icons/md';
import DefaultButton from '@/components/common/default/DefaultButton';

export default function SpiritorySelect({
  value,
  onChange,
  name,
  options,
  defaultOptionText,
  label,
  required,
  canDelete,
  ...props
}: OnBoardingSelectProps) {
  if (label) {
    return (
      <div className="tw-flex tw-w-full tw-flex-col tw-gap-3">
        <SpiritoryLabel htmlFor={name} required={required}>
          {label}
        </SpiritoryLabel>
        <div className="tw-relative">
          <select
            {...props}
            id={name}
            name={name}
            className={clsx(
              'tw-w-full tw-border !tw-border-solid tw-border-platinum-gray tw-bg-white tw-py-2.5 tw-font-plusJakartaSans tw-font-medium tw-leading-[22.68px] tw-text-[#232323] tw-outline-none focus:tw-border-2 focus:tw-ring-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-appearance-none',
              'focus:tw-border-main-shades-500 focus:tw-ring-main-shades-500',
              'tw-rounded-xl tw-px-4'
            )}
            value={value}
            onChange={onChange}
          >
            <option value="" disabled>
              {defaultOptionText}
            </option>
            {options.map(option => (
              <option key={`${option.value}-${option.label}`} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          {canDelete && (
            <DefaultButton
              className="tw-absolute tw-right-4 tw-top-1/2 tw--translate-y-1/2 tw-transform tw-cursor-pointer tw-text-slate-gray"
              aria-label="Clear"
            >
              <MdClose
                onClick={() => {
                  const event = new Event('change', { bubbles: true });
                  const input = document.getElementById(name) as HTMLSelectElement;
                  input.value = '';
                  input.dispatchEvent(event);
                }}
              />
            </DefaultButton>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="tw-relative">
      <select
        {...props}
        id={name}
        name={name}
        className={clsx(
          'tw-w-full tw-border !tw-border-solid tw-border-platinum-gray tw-bg-white tw-py-2.5 tw-font-plusJakartaSans tw-font-medium tw-leading-[22.68px] tw-text-[#232323] tw-outline-none focus:tw-border-2 focus:tw-ring-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-appearance-none',
          'focus:tw-border-main-shades-500 focus:tw-ring-main-shades-500',
          'tw-rounded-xl tw-px-4'
        )}
        value={value}
        onChange={onChange}
      >
        <option value="" disabled>
          {defaultOptionText}
        </option>
        {options.map(option => (
          <option key={`${option.value}-${option.label}`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {canDelete && (
        <DefaultButton
          className="tw-absolute tw-right-4 tw-top-1/2 tw--translate-y-1/2 tw-transform tw-cursor-pointer tw-text-slate-gray"
          aria-label="Clear"
        >
          <MdClose
            onClick={() => {
              const event = new Event('change', { bubbles: true });
              const input = document.getElementById(name) as HTMLSelectElement;
              input.value = '';
              input.dispatchEvent(event);
            }}
          />
        </DefaultButton>
      )}
    </div>
  );
}
